import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import AdminLayout from "./AdminLayout";
import "./adminTheme.css";

function resolveAdminTitle(pathname) {
  if (pathname === "/admin" || pathname === "/admin/") {
    return "แดชบอร์ดผู้ดูแล";
  }

  if (pathname === "/admin/announcements/new") {
    return "สร้างใบประกาศใหม่";
  }

  if (pathname.startsWith("/admin/announcements/")) {
    if (pathname.endsWith("/edit")) {
      return "แก้ไขใบประกาศ";
    }
    return "รายละเอียดใบประกาศ";
  }

  if (pathname.startsWith("/admin/announcements")) {
    return "รายการประกาศ";
  }

  if (pathname.startsWith("/admin/upload-announcement")) {
    return "อัปโหลดประกาศ";
  }

  if (pathname.startsWith("/admin/daily-announcements")) {
    return "การจัดการประกาศ";
  }

  if (pathname.startsWith("/admin/daily-pdf")) {
    return "Template PDF";
  }

  if (pathname.startsWith("/admin/content")) {
    return "จัดการเนื้อหาเว็บไซต์";
  }

  if (pathname.startsWith("/admin/editor")) {
    return "กองบรรณาธิการ";
  }

  if (pathname.startsWith("/admin/articles")) {
    return "ข่าว / ประชาสัมพันธ์";
  }

  if (pathname.startsWith("/admin/excel-to-pdf")) {
    return "แปลง Excel เป็น PDF";
  }

  if (pathname.startsWith("/admin/announce")) {
    return "ลงประกาศ";
  }

  return "Admin";
}

// Pages built for the redesign style themselves; the older pages get the shared reference theme
const REDESIGNED = ["/admin/editor", "/admin/content", "/admin/articles"];

function AdminRouteLayout() {
  const { pathname } = useLocation();
  const pageTitle = resolveAdminTitle(pathname);
  const legacy = !REDESIGNED.some((p) => pathname.startsWith(p));

  return (
    <AdminLayout title={pageTitle}>
      {legacy ? (
        <div className="adm-legacy">
          <Outlet />
        </div>
      ) : (
        <Outlet />
      )}
    </AdminLayout>
  );
}

export default AdminRouteLayout;
